// Ported from microsites/womens-conference/src/components/FullnessBadge.tsx verbatim.
import type { FullnessState } from '../lib/conference';

const LABEL: Record<FullnessState, string> = {
  open: 'Seats available',
  almostFull: 'Almost full',
  full: 'Full',
};

const CLASS: Record<FullnessState, string> = {
  open: 'wm-badge wm-badge-open',
  almostFull: 'wm-badge wm-badge-almost',
  full: 'wm-badge wm-badge-full',
};

/**
 * Three coarse states, never a number. "190 of 200" reads as either panic
 * or a leaderboard; "Almost full" reads as "decide soon", which is the only
 * thing an attendee needs from the count. When counts are unavailable
 * (MP briefly down) pass null and it renders nothing rather than a guess.
 */
export function FullnessBadge({ state }: { state: FullnessState | null }) {
  if (!state) return null;
  return <span className={CLASS[state]}>{LABEL[state]}</span>;
}
